import styled from "styled-components";
import FOLDER_YELLOW_SVG from "assets/images/folder_yellow.svg";
import FILE_SVG from "assets/images/file.svg";
import { folder } from "shared/types/Report";
import { hw } from "../homeworkUi";

interface FolderProps{
    folder:folder,
    selectedReport:string,
    selectedList?:string[],
    onFolderClick:(folder:folder) => void,
    onSelectClickHandler?:(id:string, value:boolean) => void,
}

const Folder = ({folder, selectedReport, onFolderClick, onSelectClickHandler, selectedList}:FolderProps) => {
    const selected = selectedReport === folder.id;
    return (
        <Container $selected={selected}>
            <TitleWrap onClick={() => onFolderClick(folder)}>
                <Icon src={folder.type === "folder" ? FOLDER_YELLOW_SVG : FILE_SVG} alt="" />
                <Name $selected={selected}>{folder.name}</Name>
            </TitleWrap>
            {onSelectClickHandler ? (
                <CheckBox
                    type="checkbox"
                    checked={selectedList?.includes(folder.id)}
                    onChange={(e) => onSelectClickHandler(folder.id, e.target.checked)}
                />
            ) : null}
        </Container>
    )
}

const Container = styled.div<{ $selected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 10px;
    border-radius: ${hw.radiusSm};
    background: ${props => props.$selected ? hw.brandSoft : "transparent"};
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
        background: ${props => props.$selected ? hw.brandSoft : hw.bg};
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-grow: 1;
    min-width: 0;
`;

const Icon = styled.img`
    width: 22px;
    height: 22px;
    flex-shrink: 0;
`;

const Name = styled.span<{ $selected: boolean }>`
    color: ${props => props.$selected ? hw.brandDark : hw.text};
    font-size: 14px;
    font-weight: ${props => props.$selected ? 600 : 500};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const CheckBox = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${hw.brand};
    cursor: pointer;
    flex-shrink: 0;
`;

export default Folder;
